/**
 * enum representing the supported log levels.
 * These match the aurelia log levels (see aurelia-logging.js)
 */
export let LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel[LogLevel["none"] = 0] = "none";
  LogLevel[LogLevel["error"] = 1] = "error";
  LogLevel[LogLevel["warn"] = 2] = "warn";
  LogLevel[LogLevel["info"] = 3] = "info";
  LogLevel[LogLevel["debug"] = 4] = "debug";
  return LogLevel;
}({});
//# sourceMappingURL=LogLevel.js.map
